import apiClient from "../api/client";

const FALLBACK_NUMBER = "+923227401538";
const FALLBACK_MESSAGE = "Hi, I am interested in HB Height and I need more information.";

// Cached in-memory after first successful fetch so repeat calls (multiple
// buttons across the page) don't each trigger a network request.
let cachedSettings = null;

const fetchSettings = async () => {
  if (cachedSettings) return cachedSettings;
  try {
    const { data } = await apiClient.get("/settings");
    cachedSettings = data;
    return data;
  } catch {
    return null;
  }
};

const openWhatsApp = async () => {
  // Open the tab synchronously (within the click's user-activation window) so
  // browsers don't block it as a popup, then navigate it once settings load.
  const win = window.open("", "_blank");

  const settings = await fetchSettings();
  const phoneNumber = settings?.whatsappNumber || FALLBACK_NUMBER;
  const message = settings?.whatsappMessage || FALLBACK_MESSAGE;

  const url = `https://wa.me/${phoneNumber.replace(/[^\d+]/g, "")}?text=${encodeURIComponent(message)}`;

  if (win) win.location.href = url;
  else window.open(url, "_blank");
};

export default openWhatsApp;
